module.exports = __webpack_public_path__ + "img/parceria-leimac.e264adcc.png";